import { FormControl, FormControlLabel, Radio, RadioGroup, Theme, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import { selectExpandedModsDialog, selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { makeStyles } from 'tss-react/mui';
import { handleHousingDeposits, isDepositRefundable } from '../../ModificationsUtils';
const useStyles = makeStyles<{ isExpanded?: boolean }>()((theme: Theme, { isExpanded }) => ({
  headerLeft: {
    display: 'block',
  },
  radioLabel: {
    color: '#333333 ',
    ' & .MuiFormControlLabel-label': {
      color: '#333333 !important',
    },
  },
}));
export const ThreeBedroomRefundableField = () => {
  const isExpanded = useSelector(selectExpandedModsDialog);
  const { t } = useTranslation();
  const { control, setValue, getValues } = useFormContext();
  const is3BedRoomDepositRefundable = 'is3BedRoomDepositRefundable';
  const [isRefundable, setRefundable] = useState<string>();
  const private3BedRoomDepositAmount: string = useWatch({ name: 'private3BedRoomDepositAmount' });
  const { classes } = useStyles({ isExpanded });
  const [showRefundable, setShowRefundable] = useState<boolean>(false);

  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const isModEdit = useSelector(selectIsEditMod);
  const handleChange = (value: string) => {
    setValue(is3BedRoomDepositRefundable, value);
    setRefundable(value);
    if (value) {
      const updateValues = handleHousingDeposits(getValues('deposits'), 3, value, 'refundable');
      setValue('deposits', updateValues);
    }
  };
  useEffect(() => {
    handleChange(isDepositRefundable(getValues('deposits'), 3));
    if (parseFloat(private3BedRoomDepositAmount) > 0) {
      setShowRefundable(true);
    } else {
      setShowRefundable(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [private3BedRoomDepositAmount]);
  return (
    <>
      {showRefundable && (
        <Controller
          control={control}
          name={is3BedRoomDepositRefundable}
          render={({ field: { onChange, value, ...rest } }) => {
            return (
              <FormControl disabled={!isModEdit || isSaveModApiCalling}>
                <div className={classes.headerLeft}>
                  <div>
                    <Typography component="span" style={{ color: '#888888' }}>{`${t(
                      'placement.placementMods.refundable',
                    )}`}</Typography>
                  </div>
                  <div style={{ marginTop: '-4px' }}>
                    <RadioGroup
                      row
                      value={isRefundable}
                      name={is3BedRoomDepositRefundable}
                      onChange={e => {
                        handleChange(e.target.value);
                        onChange(e.target.value);
                      }}
                    >
                      <FormControlLabel value={'N'} control={<Radio />} label={'No'} className={classes.radioLabel} />
                      <FormControlLabel value={'Y'} control={<Radio />} label={'Yes'} className={classes.radioLabel} />
                    </RadioGroup>
                  </div>
                </div>
              </FormControl>
            );
          }}
        />
      )}
    </>
  );
};
